module.exports = __webpack_public_path__ + "static/img/youyijia.9ee3856.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/youyijia.png
// module id = PPkx
// module chunks = 1